import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
@Component({
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  readonly progress = input<number | undefined>(undefined);
  readonly selectedLayout = input<string | undefined>(undefined);
  constructor() {}
}
